import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    successText: { type: String, default: "Copied" }
  }

  async copy() {
    const text = this.sourceTarget.textContent
    try {
      await navigator.clipboard.writeText(text)

      const originalText = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.successTextValue
      setTimeout(() => {
        this.buttonTarget.textContent = originalText
      }, 2000)
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }
}
